import { CustomTag } from "./interface";
import { emitCustomEvent } from "react-custom-events";


export function addNewTag(name: string, description: string, location: number[], dataIds: string[], inId: string | null = null) {
    // This will be replaced with a call to the backend
    const tagList = getTagList();
    let tagIds = tagList.map((tag) => parseInt(tag.id));
    tagIds = tagIds.filter((id) => !isNaN(id));
    const tags = getTagList();

    let tag
    if (!inId) {
        const maxId = tagIds.length ? Math.max(...tagIds) : 0;
        const id = (maxId + 1).toString();

        const newTag = {
            id: id,
            name: name,
            description: description,
            location: location,
            dataIds: dataIds
        }
        tags.push(newTag);
        addTag3D(newTag);
        tag = newTag;
    }else{
        tag = tags.find((tag) => tag.id === inId);
        if(tag){
            tag.name = name;
            tag.description = description
            tag.location = location;
            tag.dataIds = dataIds;
            // Remove tag from 3D viewer
            const annotations = window.potreeViewer.scene.annotations;
            const tag3D = annotations.children.find((tag: any) => tag.tagId === inId);
            if (tag3D) {
                window.potreeViewer.scene.removeAnnotation(tag3D);
            }
            addTag3D(tag);
        }
    }
    localStorage.setItem("tags", JSON.stringify(tags));
    return tag;
}

export function removeTag(inTagId: string) {
    const tags = getTagList();
    const newTags = tags.filter((tag) => tag.id !== inTagId);

    // Remove tag from 3D viewer
    const annotations = window.potreeViewer.scene.annotations;
    const tag3D = annotations.children.find((tag: any) => tag.tagId === inTagId);
    if (tag3D) {
        window.potreeViewer.scene.removeAnnotation(tag3D);
    }
    localStorage.setItem("tags", JSON.stringify(newTags));
}

export function getTagList(): CustomTag[] {
    const tagsObject = localStorage.getItem("tags");
    if (tagsObject) {
        return JSON.parse(tagsObject);
    }
    return [];
}

let addNewTagBool = false;
export function initTagUtils(inPotreeContainer: HTMLElement) {

    let canvas = inPotreeContainer.getElementsByTagName("canvas")[0];
    canvas.addEventListener("click", (e) => {
        if (!addNewTagBool) return;

        const pViewer = window.potreeViewer;
        const Potree = window.potree;
        if (!pViewer || !Potree) return;

        let I = Potree.Utils.getMousePointCloudIntersection(
            pViewer.inputHandler.mouse,
            pViewer.scene.getActiveCamera(),
            pViewer,
            pViewer.scene.pointclouds);

        if (!I) return;

        emitCustomEvent("newTag", {
            location: [I.location.x, I.location.y, I.location.z]
        });

    });

}

export function setAddNewTagBool(inBool: boolean) {
    addNewTagBool = inBool;
}

export function addTag3D(inTag: CustomTag) {
    let scene = window.potreeViewer.scene.scene;

    if (!scene) return;

    if (!inTag.location) return;

    addTagAnnotation(inTag);

}

export const addTagAnnotation = (inTag: CustomTag) => {
    if (!inTag.location) return;

    const tag = new window.potree.Annotation({
        position: [inTag.location[0], inTag.location[1], inTag.location[2]],
        title: inTag.name,
        cameraTarget: [inTag.location[0], inTag.location[1], inTag.location[2]],
        cameraPosition: [inTag.location[0], inTag.location[1], inTag.location[2] + 1000], // TODO: Change this hardcoded value
        description: inTag.description
    });
    // Update font-size
    tag.elDescription[0].style.fontSize = "15px";
    tag.elTitlebar[0].classList.add("custom-tag-titlebar");

    // aTrees.domElement.off("mouseenter");
    // aTrees.domElement.off("mouseleave");
    tag.addEventListener("click", () => {
        console.log("clicked");
    });
    tag.customType = "tag";
    tag.tagId = inTag.id;
    window.potreeViewer.scene.annotations.add(tag);
};

export function removeAllTagAnnotationsFrom3D() {
    const annotations = window.potreeViewer.scene.annotations;
    const tags = annotations.children.filter((child: any) => child.customType === "tag");

    for (let i = tags.length - 1; i >= 0; i--) {
        window.potreeViewer.scene.removeAnnotation(tags[i]);
    }
}

export function zoomToTag(inTagId: string) {
    const annotations = window.potreeViewer.scene.annotations;
    const tag = annotations.children.find((tag: any) => tag.tagId === inTagId);
    if (tag) {
        window.potreeViewer.scene.view.position.copy(tag.cameraPosition);
        window.potreeViewer.scene.view.lookAt(tag.cameraTarget);
    }
}